import { Checkbox, FormControlLabel, styled } from "@mui/material";
import React from "react";

import { ReactComponent as CHECKICON } from "../../build/images/helpSideContent/tick.svg";

const CustomIcon = {
  checkbox: (
    <span
      className="custom-icon"
      style={{
        width: 16,
        height: 16,
        borderRadius: 4,
        border: "2px solid #B2C0D0    ",
        display: "inline-block",
      }}
    />
  ),
  radio: (
    <span
      className="custom-icon"
      style={{
        width: 16,
        height: 16,
        borderRadius: "50%",
        border: "2px solid #B2C0D0    ",
        display: "inline-block",
      }}
    />
  ),
};

const CustomCheckedIcon = {
  checkbox: (
    <span
      className="custom-checked-icon"
      style={{
        width: 16,
        height: 16,
        borderRadius: 4,
        backgroundColor: "#395ABF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontSize: 14,
        fontWeight: "bold",
      }}
    >
      <CHECKICON />
    </span>
  ),
  radio: (
    <span
      className="custom-checked-icon"
      style={{
        width: 16,
        height: 16,
        borderRadius: "50%",
        backgroundColor: "#395ABF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontSize: 14,
        fontWeight: "bold",
      }}
    >
      <CHECKICON />
    </span>
  ),
};

const CustomCheckboxTheme = styled(Checkbox)(({ theme }) => ({
  "&:hover": {
    backgroundColor: "transparent", // remove fundo do hover do MUI
  },
  "&:hover .custom-icon": {
    borderColor: "#304C9A", // muda a borda quando hover e não marcado
  },
  color: "#B2C0D0", // cor da borda padrão
  "&.Mui-checked": {
    color: "#395ABF", // cor do checkbox ativo (roxo escuro)
  },
  "&.Mui-disabled": {
    color: "#EFF2F6",
  },
  "& .MuiSvgIcon-root": {
    borderRadius: 4,
  },
}));

const CustomCheckbox = ({ checked, model = "checkbox", ...props }) => {
  return (
    <FormControlLabel
      sx={{ margin: "0px" }}
      control={
        <CustomCheckboxTheme
          checked={checked}
          icon={CustomIcon[model]}
          checkedIcon={CustomCheckedIcon[model]}
          //   disableRipple
        />
      }
      {...props}
    />
  );
};
export default CustomCheckbox;
